let token: string | null = null;
let subscribers: Array<(t: string | null) => void> = [];
let onRefreshFailedCb: (() => void) | null = null;

export const getAccessToken = () => token;

export const setAccessToken = (t: string | null) => {
  token = t;
  subscribers.forEach((s) => s(t));
};

export const subscribe = (cb: (t: string | null) => void) => {
  subscribers.push(cb);
  return () => {
    subscribers = subscribers.filter((s) => s !== cb);
  };
};

export const setOnRefreshFailed = (cb: () => void) => {
  onRefreshFailedCb = cb;
};

export const callOnRefreshFailed = () => {
  if (onRefreshFailedCb) onRefreshFailedCb();
};

const tokenStore = { getAccessToken, setAccessToken, subscribe };
export default tokenStore;
